import 'vue/jsx'

// 引入windi css
import '@/plugins/unocss'

// 导入全局的svg图标
import '@/plugins/svgIcon'

// 初始化多语言
import { setupI18n } from '@/plugins/vueI18n'

// 引入状态管理
import { setupStore } from '@/store'

// 全局组件
import { setupGlobCom } from '@/components'

// 引入element-plus
import { setupElementPlus } from '@/plugins/elementPlus'

// 引入全局样式
import '@/styles/index.less'

// 引入动画
import '@/plugins/animate.css'

// 路由
import { setupRouter } from './router'

// 权限
import { setupPermission } from './directives'

import { createApp } from 'vue'

import App from './App.vue'

import './permission'

import { consumePreviewTenantFromUrl } from '@/utils/previewTenant'

// 日志与埋点（阿里云 SLS）
import { setupGlobalTracking, logError, logInfo } from '@/utils/tracker'

// 引入打印插件
import { hiPrintPlugin } from 'vue-plugin-hiprint'

// 新窗口「查看数据」入口：尽早从 URL 写入本标签页 sessionStorage
consumePreviewTenantFromUrl()

// 尽早安装：JS 异常 / Promise 拒绝 / 资源加载失败 的全局捕获
setupGlobalTracking()

// 创建实例
const setupAll = async () => {
  const app = createApp(App)

  // Vue 组件内部异常（渲染、生命周期、watcher 等）
  app.config.errorHandler = (err, _instance, info) => {
    const e = err as Error
    logError('vue_error', {
      error_message: e?.message ?? String(err),
      stack: e?.stack ?? '',
      vue_info: info // 出错阶段，如 "render function"
    })
    // 保留控制台输出，便于本地开发排查
    console.error(err)
  }

  await setupI18n(app)

  setupStore(app)

  setupGlobCom(app)

  setupElementPlus(app)

  setupRouter(app)

  setupPermission(app)

  app.use(hiPrintPlugin, '$printer', false)

  app.mount('#app')

  // 应用启动完成：可用于统计启动量与首屏耗时
  logInfo('app_start', {
    load_ms: Math.round(performance.now()),
    referrer: document.referrer || ''
  })
}

setupAll()
